import styled from 'styled-components'

export default styled.label`
  color: #7C909C;
  display: block;
  font-weight: 400;
  margin-bottom: 0.25rem;
`



// WEBPACK FOOTER //
// ./src/components/Label/index.js